module.exports = __webpack_public_path__ + "static/media/8.223f1203.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/九宫格未选中态/8.png
// module id = 1272
// module chunks = 0